module.exports = __webpack_public_path__ + "static/img/EcoStruxure-Building-Operation.b1fce20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/EcoStruxure-Building-Operation.jpg
// module id = iww5
// module chunks = 0